import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-evo-input-id',
  templateUrl: './evo-input-id.component.html',
  styleUrls: ['./evo-input-id.component.css']
})
export class EvoInputIdComponent implements OnInit {

  @Input() title: string;
  @Input() placeholder: string;

  @Input() idValue: string;
  @Input() value: string;

  @Input() showIdButton = false;
  @Input() showSearchButton = true;

  @Output() valueEnterEvent = new EventEmitter<any>();
  @Output() valueChangedEvent = new EventEmitter<any>();

  @Output() idEnterEvent = new EventEmitter<any>();
  @Output() idChangedEvent = new EventEmitter<any>();

  /**
   * Sends an output when we have an empty string to reset search
   */
  @Output() onEmpty = new EventEmitter<void>();

  idFilterActive = false;

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit() {
  }

  getValue(): string {

    if (this.idFilterActive) {
      return this.idValue;
    }

    return this.value;

  }

  onValueChanged(value: string) {

    if (this.idFilterActive) {

      this.idValue = value;
      if (this.idChangedEvent) {
        this.idChangedEvent.emit(this.idValue);
      }

    } else {

      this.value = value;
      if (this.valueChangedEvent) {
        this.valueChangedEvent.emit(this.value);
      }

    }

    if (!value || value.length === 0) {
      if (this.onEmpty) {
        this.onEmpty.emit();
      }
    }

  }

  onEnter() {

    if (this.idFilterActive && this.idEnterEvent) {
      this.idEnterEvent.emit(this.idValue);
    } else if (this.valueEnterEvent) {
      this.valueEnterEvent.emit(this.value);
    }

  }

  onChangeValueFilter() {
    this.idFilterActive = !this.idFilterActive;
    this.cd.detectChanges();
  }

  rightOffsetIdButton(): string {

    if (this.showSearchButton) {

      return '66px';

    }

    return '6px';
  }

  yOffset(): string {

    if (this.title) {

      return '24.5px';
    }

    // Has a 6px height by default
    // add 4 to center the id field
    return '10px';
  }

  inputWidth(): string {

    if (this.showIdButton === false && this.showSearchButton === false) {

      return 'calc(100% - 22px)';
    } else if (this.showIdButton === false || this.showSearchButton === false) {

      return 'calc(100% - 80px)';
    }

    return 'calc(100% - 142px)';
  }

}
